// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2eTJI","tab":"Tabs_tab__3MABl","tabActive":"Tabs_tabActive__2Ga1W"};